import React from 'react';
import { Modal } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

/**
 *
 * @param {import('@chakra-ui/react').ModalProps } param0
 * @returns
 */
const CustomModal = ({ isOpen, ...rest }) => {
	const isSupportWidgetOpen = useSelector(
		(state) => state.supportWidget.widgetIsOpen
	);
	const subscriptionsCheckoutModalIsOpen = useSelector(
		/**
		 *
		 * @param {{subscriptions: import('../../../redux/reducers/types/subscriptionsReducer').default}} state
		 * @returns
		 */
		(state) => state.subscriptions.checkoutModalIsOpen
	);

	return (
		<Modal
			isOpen={isOpen}
			trapFocus={
				isOpen && (isSupportWidgetOpen || subscriptionsCheckoutModalIsOpen)
					? false
					: true
			}
			{...rest}
		/>
	);
};

export default CustomModal;
